import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import { StackView } from '@planningcenter/tapestry-react'
import { Link as SharedLink, PageHeading, Text } from '../../shared/typography'

export default function page() {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Authentication</PageHeading>

      <Text>
        Every request to the Planning Center API is made on behalf of a user.
        Permissions are dependent on the access of this user. This also means
        that when the access a user is granted has changed, their permission in
        the API will change as well.
      </Text>

      <Text>
        There are two ways to authenticate with the API:{' '}
        <Link to="/overview/authentication/personal-access-token">
          Personal Access Tokens
        </Link>{' '}
        and <Link to="/overview/authentication/oauth-2-0">OAuth</Link>.
      </Text>

      <Text>
        Personal Access Token and OAuth secrets should never be posted publicly.
        If you need to revoke your tokens, visit{' '}
        <Link
          to="https://api.planningcenteronline.com/oauth/applications"
          external
        >
          your developer account
        </Link>{' '}
        and delete the impacted tokens. If at any time they are found to be
        publicly available they will be disabled automatically.
      </Text>
    </StackView>
  )
}

function Link({ external, ...props }) {
  return external ? (
    <SharedLink external {...props} />
  ) : (
    <ReactRouterLink component={SharedLink} {...props} />
  )
}
